module.exports = __webpack_public_path__ + "static/lion-a827aa019253694eae0ffb222e79b556.png";